/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterFieldAddPost } from '../fn/field/api-master-field-add-post';
import { ApiMasterFieldAddPost$Params } from '../fn/field/api-master-field-add-post';
import { apiMasterFieldDeleteGet } from '../fn/field/api-master-field-delete-get';
import { ApiMasterFieldDeleteGet$Params } from '../fn/field/api-master-field-delete-get';
import { apiMasterFieldEditPost } from '../fn/field/api-master-field-edit-post';
import { ApiMasterFieldEditPost$Params } from '../fn/field/api-master-field-edit-post';
import { apiMasterFieldGetActiveGet } from '../fn/field/api-master-field-get-active-get';
import { ApiMasterFieldGetActiveGet$Params } from '../fn/field/api-master-field-get-active-get';
import { apiMasterFieldGetAllFieldTypeGet } from '../fn/field/api-master-field-get-all-field-type-get';
import { ApiMasterFieldGetAllFieldTypeGet$Params } from '../fn/field/api-master-field-get-all-field-type-get';
import { apiMasterFieldGetAllGet } from '../fn/field/api-master-field-get-all-get';
import { ApiMasterFieldGetAllGet$Params } from '../fn/field/api-master-field-get-all-get';
import { apiMasterFieldGetAllInputFieldGet } from '../fn/field/api-master-field-get-all-input-field-get';
import { ApiMasterFieldGetAllInputFieldGet$Params } from '../fn/field/api-master-field-get-all-input-field-get';
import { apiMasterFieldGetByCriteriaPost } from '../fn/field/api-master-field-get-by-criteria-post';
import { ApiMasterFieldGetByCriteriaPost$Params } from '../fn/field/api-master-field-get-by-criteria-post';
import { Field } from '../models/field';
import { FieldApiRespModel } from '../models/field-api-resp-model';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';

@Injectable({ providedIn: 'root' })
export class FieldService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterFieldAddPost()` */
  static readonly ApiMasterFieldAddPostPath = '/api/Master/Field/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldAddPost$Response(params?: ApiMasterFieldAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FieldApiRespModel>> {
    return apiMasterFieldAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldAddPost(params?: ApiMasterFieldAddPost$Params, context?: HttpContext): Observable<FieldApiRespModel> {
    return this.apiMasterFieldAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FieldApiRespModel>): FieldApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldEditPost()` */
  static readonly ApiMasterFieldEditPostPath = '/api/Master/Field/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldEditPost$Response(params?: ApiMasterFieldEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FieldApiRespModel>> {
    return apiMasterFieldEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldEditPost(params?: ApiMasterFieldEditPost$Params, context?: HttpContext): Observable<FieldApiRespModel> {
    return this.apiMasterFieldEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FieldApiRespModel>): FieldApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldDeleteGet()` */
  static readonly ApiMasterFieldDeleteGetPath = '/api/Master/Field/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldDeleteGet$Response(params?: ApiMasterFieldDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterFieldDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldDeleteGet(params?: ApiMasterFieldDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterFieldDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldGetAllFieldTypeGet()` */
  static readonly ApiMasterFieldGetAllFieldTypeGetPath = '/api/Master/Field/GetAllFieldType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldGetAllFieldTypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetAllFieldTypeGet$Response(params?: ApiMasterFieldGetAllFieldTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiMasterFieldGetAllFieldTypeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldGetAllFieldTypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetAllFieldTypeGet(params?: ApiMasterFieldGetAllFieldTypeGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiMasterFieldGetAllFieldTypeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldGetAllInputFieldGet()` */
  static readonly ApiMasterFieldGetAllInputFieldGetPath = '/api/Master/Field/GetAllInputField';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldGetAllInputFieldGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetAllInputFieldGet$Response(params?: ApiMasterFieldGetAllInputFieldGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiMasterFieldGetAllInputFieldGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldGetAllInputFieldGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetAllInputFieldGet(params?: ApiMasterFieldGetAllInputFieldGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiMasterFieldGetAllInputFieldGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldGetAllGet()` */
  static readonly ApiMasterFieldGetAllGetPath = '/api/Master/Field/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetAllGet$Response(params?: ApiMasterFieldGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Field>>> {
    return apiMasterFieldGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetAllGet(params?: ApiMasterFieldGetAllGet$Params, context?: HttpContext): Observable<Array<Field>> {
    return this.apiMasterFieldGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Field>>): Array<Field> => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldGetByCriteriaPost()` */
  static readonly ApiMasterFieldGetByCriteriaPostPath = '/api/Master/Field/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldGetByCriteriaPost$Response(params?: ApiMasterFieldGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Field>>> {
    return apiMasterFieldGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldGetByCriteriaPost(params?: ApiMasterFieldGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Field>> {
    return this.apiMasterFieldGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Field>>): Array<Field> => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldGetActiveGet()` */
  static readonly ApiMasterFieldGetActiveGetPath = '/api/Master/Field/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetActiveGet$Response(params?: ApiMasterFieldGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Field>>> {
    return apiMasterFieldGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldGetActiveGet(params?: ApiMasterFieldGetActiveGet$Params, context?: HttpContext): Observable<Array<Field>> {
    return this.apiMasterFieldGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Field>>): Array<Field> => r.body)
    );
  }

}
